import React from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {useUserStore} from '../../store/user';

interface AuthRouteProps {
    children: React.ReactNode;
}

export default function AuthRoute({children}: AuthRouteProps) {
    const {isLoggedIn} = useUserStore();
    const location = useLocation();

    // TODO: 인증이 필요한 화면에 미인증상태로 접근시 얼럿은 여기서 ?

    if (!isLoggedIn) {
        return <Navigate to='/login' state={{from: location}} replace />;
    }

    return <>{children}</>;
}
